<template>
	<span>
		<v-btn class="top-menu-buttons white-color-buttons admin-toolbar-buttons" v-bind:class="{'selected-color':selectDepartmentId === department.id}" flat dark small @click="selectDepartmentFilter()">
			{{ department.name | translate(`department.${department.id}.name`) }}
			<template v-if="pendingCount">&nbsp;
				<span :class="['products-count', { 'error': pendingWarning }]">{{ pendingCount }}</span>
			</template>
		</v-btn>
	</span>
</template>

<script>
	import {mapGetters} from "vuex";
	import * as Types from "../../store/mutation-types";
	import OrderHelperObject from "../../domains2/orders/OrderHelperObject";

	export default {
		name: "DepartmentButton",
		props: ["department"],
		computed: {
			...mapGetters(["pendingOrders", "selectDepartmentId"]),
			pendingOrdersForThis(){
				const self = this;
				return self.pendingOrders.filter(o => OrderHelperObject.isInTheDepartment(o, self.department));
			},
			pendingCount() {
				return this.pendingOrdersForThis.length;
			},
			pendingWarning() {
				return this.pendingOrdersForThis.some(o => o.pendingOverdue);
			}
		},
		methods: {
			selectDepartmentFilter() {
				this.$store.dispatch(Types.ADMIN_SELECT_DEPARTMENT, this.department.id === this.selectDepartmentId ? null : this.department.id);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.products-count {
		line-height: 18px;
		padding: 2px 2px 2px 1.5px;
		min-width: 22px;
		min-height: 20px;
		background-color: #ffc36d;
		border-radius: 50%;
		font-weight: bold;
		color: #4a4a4a;
		font-size: 12px !important;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.selected-color {
		background-color: #5294b6 !important;
	}

	.v-toolbar__items .v-btn {
		margin: 6px 3px !important;
	}

</style>
